import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { signup } from "../services/authService"; // Import signup function
import { toast } from "react-toastify";

const SignupModal = ({
  show,
  handleClose,
  openLoginModal,
  closeSignupModal,
}) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    try {
      const signupData = {
        name,
        phone,
        email,
        password,
      };
      const response = await signup(signupData);
      console.log("Signup Success:", response);
      toast.success("Signup Successful!");
      handleClose(); // ✅ Close after successful signup
      // Optional: Open Login Modal after signup success
      // openLoginModal();
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error(error);
    }
  };

  const handleAlreadyHaveAccount = () => {
    closeSignupModal(); // Close Signup Modal
    openLoginModal(); // Open Login Modal
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center fw-bold">SIGN UP</Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4">
        <Form onSubmit={handleSignup}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="signupName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="signupPhone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="signupEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="signupPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="signupConfirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button
            type="submit"
            className="w-100 my-3"
            style={{
              backgroundColor: "#FFA500",
              borderColor: "#FFA500",
              fontWeight: "bold",
            }}
          >
            SIGN UP
          </Button>
        </Form>
      </Modal.Body>

      <div className="px-4 pb-4 text-center">
        <hr />
        <div className="fw-bold">ALREADY HAVE AN ACCOUNT?</div>
        <button
          onClick={handleAlreadyHaveAccount}
          className="btn btn-link text-decoration-none fw-bold"
          style={{ color: "#FFA500" }}
        >
          LOGIN
        </button>
      </div>
    </Modal>
  );
};

export default SignupModal;
